<template>
  <div class="panel_wrapper panel_wrapper_56">
    <dv-border-box-12 :color="['#227ead', 'rgb(124, 231, 253)']">
      <div class="pad_6 s_title">
        <div class="title_l">水平衡监测</div>
        <div class="title_r">
          <!--<el-switch
            class="switchStyle"
            @change="switchChange"
            :width="70"
            v-model="switchVal"
            active-color="#13ce66"
            inactive-color="#FF8C00"
            active-text="列表"
            inactive-text="图形"
          ></el-switch>-->
        </div>
      </div>
      <div class="water_balance_wrap">
        <el-date-picker
          v-model="dateValue"
          type="daterange"
          align="left"
          unlink-panels
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          :picker-options="pickerOptions"
        ></el-date-picker>
        <el-button style="margin-left:20px" size="mini" @click="queryDate" type="primary">
          <span>查询</span>
        </el-button>
        <el-button 
          style="margin-left:20px"
          size="mini"
          @click="exportExcel"
          type="success">
          <span>导出数据</span>
        </el-button>  
        <div class="baseMap" v-if="!switchVal" ref="baseMapRef">
          <mingMap class="mingMap" ref='tree222'  />
        
        </div>
        <div class="baseList" v-else ref="baseListRef">
          <el-scrollbar>
            <tree-table
              class="treeTable"
              ref="treeTableRef"
              :is-fold="false"
              headerAlign="center"
              :data="treeTableData"
              :columns="columns"
              :selection-type="false"
              :expand-type="false"
              :show-row-hover="false"
            >
            <!--
              <template slot="operate" slot-scope="scope">
                <el-button type="primary" size="mini">历史数据</el-button>
              </template>
              -->
            </tree-table>
          </el-scrollbar>
        </div>
      </div>
    </dv-border-box-12>
  </div>
</template>

<script>
import mingMap from "./mingMap.vue";
import util from '@/mixins/util.js'
export default {
  components: {
    mingMap
  },
  data() {
    return {
      switchVal: true,
      horizontal: true,
      collapsable: true,
      expandAll: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 8);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 31);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 91);
              end.setTime(end.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      wormIndex: [],
      dateValue: "",
      treeTableHeight: "200px",
      treeTableData: [],
      columns: [
        { label: "区域名称", prop: "name", minWidth: "160px" },
        { label: "区域分级", prop: "levelDesc", minWidth: "80px" },
        { label: "供水量(m³)", prop: "wateruse", minWidth: "50px" },
        { label: "用水量(m³)", prop: "childuse", minWidth: "50px" },
        { label: "误差量(m³)", prop: "pc", minWidth: "50px " },
        { label: "误差率(%)", prop: "pcl", minWidth: "50px " },
        { label: "水平衡结果", prop: "isWormDesc", minWidth: "100px " },
        /*{
          label: "操作",
          minWidth: "100px ",
          type: "template",
          template: "operate"
        }*/
      ]
    };
  },
  created() {
    const end = new Date();
    const start = new Date();
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 31);
    end.setTime(end.getTime() - 3600 * 1000 * 24);
    //const end = new Date();
    //end.setTime(end.getTime() - 3600 * 1000 * 24);
    this.dateValue = [start, end];
    sessionStorage.setItem('phStart',end);
    sessionStorage.setItem('phEnd',end);
    this.getData();
  },
  mounted() {
    this.setTreeTable();
  },
  methods: {
    switchChange() {
      this.setTreeTable();
    },
    queryDate() {
      console.log(this.dateValue);
      sessionStorage.setItem('phStart',this.dateValue[0]);
      sessionStorage.setItem('phEnd',this.dateValue[1]);
      this.getData();
    },
    dataToStr(date) {
      var year = date.getFullYear(); //年
      var month = date.getMonth() + 1; //月
      var day = date.getDate(); //日
      if (month < 10) {
        month = "0" + month;
      }
      if (day < 10) {
        day = "0" + day;
      }
      return year + "-" + month + "-" + day;
    },
    getData() {
      var that = this;

      this.$post("/apis/manage/home/allPlaceMsg", {
        token: sessionStorage.getItem("token"),
        startTime: this.dataToStr(this.dateValue[0]),
        endTime: this.dataToStr(this.dateValue[1])
      })
        .then(function(res) {
          if (res.errno == 0) {
            var data = res.data;
            that.treeTableData = data;
            that.setTreeTable();
            //that.$refs.tree.setTreeData(data);
          }
        })
        .catch(function(err) {
          window.console.log(err);
        });
    },
    // 导出excel格式
    exportExcel() {
      // 树结构转一维数组
      console.log(this.treeTableData)
      let arr = util.toSPHArr(this.treeTableData)
      console.log('arr');
        console.log(arr);
      require.ensure([], () => {
        const {export_json_to_excel} = require('@/excel/Export2Excel')
        const tHeader = ['区域名称', '区域分级', '供水量(m³)', '用水量(m³)', '误差量(m³)', '误差率(%)', '水平衡结果']
        const filterVal = ['name', 'levelDesc', 'wateruse', 'childuse', 'pc', 'pcl', 'isWormDesc'];
        const list = arr
        const data = this.formatJson(filterVal, list)
        console.log('data');
        console.log(data);
        var title = sessionStorage.getItem("companyName") + '水平衡';
        var startTime = this.dataToStr(this.dateValue[0])
        var endTime = this.dataToStr(this.dateValue[1])
        if(startTime == endTime){
          title += ('('+startTime+')');
        }else{
          title += ('('+startTime+'~'+endTime+')');
        }
        export_json_to_excel(tHeader, data, title)
      })
      
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
    checkIsWorm(data, index) {
      var tempIndex = index;
      if (data.isWorm) {
        this.wormIndex.push(index);
      }
      if (data.children.length > 0) {
        for (var i = 0; i < data.children.length; i++) {
          tempIndex = this.checkIsWorm(data.children[i], tempIndex+1);
        }
      }
      return tempIndex ;
    },
    setTreeTable() {
      var that = this;
      if (this.switchVal) {
        this.$nextTick(function() {
          let baseListRefHeight = this.$refs.baseListRef.offsetHeight - 64 - 8;
          let treeTable = document.querySelector(".zk-table__body-wrapper");
          treeTable.style.height = baseListRefHeight + "px";

          that.wormIndex = [];
          
          var index = 0;
          for (var i = 0; i < that.treeTableData.length; i++) {
            index = that.checkIsWorm(that.treeTableData[i], index);
          }
          console.log(that.wormIndex)
          var rows = document.querySelectorAll(".zk-table__body-row");
          for(var i=0;i<rows.length;i++){
            rows[i].style.color = " #C3DBFF";
          }
          //document.querySelectorAll(".zk-table__body-row").style.color = " #C3DBFF";
          //根据后端提供报警标志设置表格变红报警
          for (var item in that.wormIndex) {
            console.log('item:'+item)
            let rowData = document.querySelectorAll(".zk-table__body-row")[
              that.wormIndex[item]
            ];
            rowData.style.color = "	#DC193A";
          }

          // 监听窗口大小变化
          window.onresize = function() {
            treeTable.style.height = baseListRefHeight + "px";
          };
        });
      } 
    },

  }
};
</script>

<style lang="less" scoped>
.s_title {
  width: 98%;
  height: 48px;
  display: flex;
  .title_l {
    flex: 1;
    width: 130px;
    line-height: 30px;
    border-radius: 2px;
    font-size: 18px;
    text-align: center;
    color: rgb(143, 185, 196);
    box-shadow: 0px 0px 21px rgb(152, 175, 182) inset;
  }
  .title_r {
    flex: 3;
    display: flex;
    padding-top: 12px;
    justify-content: flex-end;

    // 3d列表选择
    /deep/.switchStyle {
      .el-switch__label {
        position: absolute;
        // 兼容ie10 11
        top: 0px;
        display: none;
        color: #f0f0f0;
      }

      .el-switch__label--right {
        z-index: 9;
        right: 20px;
        font-weight: 700;
      }

      .el-switch__label--left {
        z-index: 9;
        left: 32px;
        font-weight: 700;
      }

      .el-switch__label.is-active {
        display: block;
      }

      .el-switch .el-switch__core,
      .el-switch .el-switch__label {
        width: 50px !important;
      }
    }
  }
}
.water_balance_wrap {
  width: 98%;
  height: calc(100% - 88px);
  margin: 0 auto;
  .baseList {
    width: 100%;
    height: 100%;

    .treeTable {
      width: 100%;
      margin: 8px auto;
      border: none;

      /deep/.zk-table__header-row {
        font-size: 14px;
        background-color: #1c4da6;
        border-bottom: none;
        color: #dedede;
      }
      /deep/ .zk-table__body {
        border-collapse: separate;
      }
      /deep/ .zk-table__body-wrapper {
        width: 100%;
        background-color: #133049;
        color: #c3dbff;
      }
    }
  }
  .baseMap {
    width: 100%;
    height: 100%;
    overflow: auto;
    .mingMap {
      width: 100%;
      margin: 8px auto;
    }
  }

  // 日期选择器
  /deep/.el-input__inner {
    background: 000;
    border: 1px solid #227ead;
    border-radius: 6px;
    color: #adadad;
  }
  /deep/.el-range-input {
    background-color: #133049;
    color: #dedede;
  }
  /deep/.el-range-separator {
    color: #dedede;
  }
  /deep/.el-picker-panel__sidebar {
    background-color: #133049;
  }
}

.text-center {
    width: 100%;
    height: 100%;
    /deep/.org-tree-container {
      background-color: transparent;
      -webkit-box-shadow: 0 0;
      box-shadow: 0 0;
    }
    /deep/.org-tree-node-label-inner {
      color: #c3dbff;
      box-shadow: 0 0;
    }
    /deep/.org-tree-node-btn {
      background-color: rgb(78, 92, 109)
    }
    .org-tree-node-label {
      white-space: nowrap;
    }
  }
</style>